<template>
    <div class="activities-status-icon-button">
        <CompassTooltip
            :disabled="tooltipDisabled"
            :arrow="false"
            :content="tooltipContent"
            :contentClass="tooltipContentClass"
            :placement="tooltipPlacement"
        >
            <CompassIconButton
                ref="iconButton"
                :size="size"
                :icon="icon"
                :class="iconClass"
                :loading="pending"
                :disabled="disabled && !pending"
                data-bot="activities-listing__action-status-icon-button"
                @click.stop="toggleStatus"
            />
        </CompassTooltip>
    </div>
</template>

<script>
import activitiesListingMixins from 'mixins/activities/activitiesListingMixins';

export default {
    mixins: [activitiesListingMixins],

    props: {
        canUpdate: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'medium',
        },
        pending: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            required: true,
        },
    },

    computed: {
        icon() {
            return this.isActive ? 'success-circle-fill' : 'success-circle';
        },
        iconClass() {
            return {
                'is-active': this.isActive,
                'is-disabled': this.disabled,
                'is-pending': this.pending,
            };
        },
        tooltipDisabled() {
            if ([this.ACTIVITY_TYPES.EMAIL, this.ACTIVITY_TYPES.EVENT].includes(this.type)) {
                return true;
            }
            return this.pending;
        },
        tooltipPlacement() {
            return this.type === this.ACTIVITY_TYPES.EVENT ||
                this.type === this.ACTIVITY_TYPES.EMAIL
                ? 'bottom-start'
                : 'bottom';
        },
        tooltipContentClass() {
            return this.pending ? 'activities-status-icon-button-tooltip-content--is-pending' : '';
        },
        tooltipContent() {
            if (!this.canUpdate) {
                return this.$t.__('common.labels.no_permissions_to_perform_this_action');
            }
            let content;
            switch (this.type) {
                case this.ACTIVITY_TYPES.EVENT:
                    content = this.$l10n.__(
                        "L'activité passera automatiquement en Terminée une fois l'événement passé",
                    );
                    break;
                case this.ACTIVITY_TYPES.EMAIL:
                    content = this.$l10n.__(
                        "L'activité passera automatiquement en Terminée après l'envoi de l'e-mail",
                    );
                    break;
                default:
                    content = this.isActive
                        ? this.$l10n.__('Marquer comme à faire')
                        : this.$l10n.__('Marquer comme terminé');
                    break;
            }
            return content;
        },
    },
    methods: {
        toggleStatus() {
            if (!this.pending) {
                this.$emit('clicked');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.activities-status-icon-button:deep() {
    .is-active:not(.is-disabled) > .compass-icon-button__content {
        &:hover {
            background-color: var(--colors-common-background-success-subtle);
        }

        .compass-icon {
            color: var(--colors-common-text-success-hover);
        }
    }
}
</style>
<style>
.activities-status-icon-button-tooltip-content--is-pending {
    visibility: hidden;
    opacity: 0;
}
</style>
